module.exports = __webpack_public_path__ + "media/images/levelup_bg_sp-03526c13502fb70409af8fbb47388772.png";